import { queryOptions } from "@tanstack/react-query";
import { createQueryGroup } from "../../core/api/queries";
import { PlanOfCareTypeId } from "../../shared/schema/schema";

export default createQueryGroup(({ api }) => ({
  settings: () =>
    queryOptions({
      queryKey: ["planOfCareType", "settings"],
      queryFn: () =>
        api.get("/agencies/:agencyId/coordinator/:agencyMemberId/plan_of_care_settings", {}),
    }),

  /**
   * Unlike `settings`, this returns inactive items too, so the editor can show and reactivate
   * them, and it carries the usage counts used to warn before deactivating.
   */
  items: (planOfCareTypeId: PlanOfCareTypeId) =>
    queryOptions({
      queryKey: ["planOfCareType", "items", planOfCareTypeId],
      queryFn: () =>
        api.get("./plan_of_care_type/:planOfCareTypeId/items", { path: { planOfCareTypeId } }),
    }),

  defaultTaskItems: () =>
    queryOptions({
      queryKey: ["planOfCareType", "defaultTaskItems"],
      queryFn: () => api.get("./default_poc_task_items", {}),
    }),
}));
